import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import GradientButton from "../../buttons/gradientButton/GradientButton";
import { getRequestItemCount } from "../../../redux/marketplaceRequest/reducer";
import "./CartButton.scss";

const CartButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("marketplace");
  const itemCount = useSelector(getRequestItemCount);

  return (
    <div className="cart-button">
      <GradientButton onPress={() => navigate("/dashboard/marketplace-cart")}>
        {`${t("provider.your_products")} (${itemCount})`}
      </GradientButton>
    </div>
  );
};

export default CartButton;
